<template>
  <CContainer>
    <TheAsideBar />
    <TheSidebar />
    <CWrapper class="justify-content-between">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </CWrapper>
  </CContainer>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheAsideBar from "./TheAsideBar";

export default {
  name: "TheMainSidebar",
  components: {
    TheSidebar,
    TheAsideBar
  }
};
</script>

<style>
</style>
